export default __webpack_public_path__ + "static/media/13.f58a944c.jpg";